import React from 'react';

const Accordion = ({items, name}) => {

    const renderQuestion = (item, index) => {
        return (
            <div className="accordion__item">
                <label className="item" htmlFor={`${name}-${index}`}>
                    <input id={`${name}-${index}`} type="radio" name={name} defaultChecked={index === 0} />
                    <div className="accordion__item-title">{item.question}</div>
                    <div className="accordion__item-body">
                        <p>
                            {item.answer}
                        </p>
                    </div>
                </label>
            </div>
        )
    };

    return (
        <div className="accordion">
            { items.map(renderQuestion) }
        </div>
    )
};

export default Accordion;


// WEBPACK FOOTER //
// ./src/components/accordion/index.js